import React, { useState, useContext, useEffect  } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import s from '../styles/Register.module.css';
import PolicyModal from './orders/PolicyModal'; // путь проверь
import eyeOpenIcon from '../assets/icons/eye_open.svg';
import eyeClosedIcon from '../assets/icons/eye_closed.svg';


function Register({ privacyConsent, marketingConsent, onPrivacyChange, onMarketingChange }) {
  const [formData, setFormData] = useState({
    login: '',
    password: '',
    name: '',
    referrer_code: '',
    offer_id: '',
    pulse_referrer: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { fetchCurrentUser } = useContext(AuthContext);
  const [localPrivacyConsent, setLocalPrivacyConsent] = useState(false);
  const [localMarketingConsent, setLocalMarketingConsent] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);

  const agreed = privacyConsent ?? localPrivacyConsent;
  const marketingAgreed = marketingConsent ?? localMarketingConsent;


  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };


  // вспомогательная функция
const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};

useEffect(() => {
  const referrer_code = getCookie('referrer_code');
  const offer_id = getCookie('offer_id');
  const pulse_referrer = getCookie('pulse_referrer');
  setFormData((prev) => ({
    ...prev,
    referrer_code: referrer_code || '',
    offer_id: offer_id || '',
    pulse_referrer: pulse_referrer || ''
  }));
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(formData.login)) {
      setError('Введите корректный email.');
      return;
    }

    if (!agreed) {
      setError('Для регистрации необходимо согласие с Политикой конфиденциальности.');
      return;
    }

    try {
      const res = await fetch('/api/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          privacy_consent: agreed,
          marketing_consent: marketingAgreed
        }),
      });
      const result = await res.json();

      if (res.ok) {
        setSuccess(true);

        // Автоматический вход
        const loginRes = await fetch('/api/auth/login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            login: formData.login,
            password: formData.password
          })
        });

        if (loginRes.ok) {
          const loginData = await loginRes.json();
          if (loginData.token) {
            localStorage.setItem('user_token', loginData.token);
            localStorage.setItem('user_role', loginData.user_role || 'user');
          }
          await fetchCurrentUser();
          navigate('/dashboard');
        } else {
          setError('Регистрация прошла успешно, но вход не выполнен.');
        }
      } else {
        setError(result.error || 'Ошибка регистрации.');
      }
    } catch (err) {
      console.error(err);
      setError('Сетевая ошибка. Попробуйте позже.');
    }
  };

  return (
      <div className={s.login_container}>
        <div className={s.login_form}>
          {error && <div className={s.error}>{error}</div>}
          {success ? (
            <div>Регистрация успешна!</div>
          ) : (
            <form  className={s.login_form_form} onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Имя"
                value={formData.name}
                onChange={handleChange}
                required
                className={s.login_form_input}
              />
              <input
                type="text"
                name="login"
                placeholder="Логин (email)"
                value={formData.login}
                onChange={handleChange}
                required
                className={s.login_form_input}
              />
              <div className={s.input_with_toggle}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder="Пароль"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className={`${s.login_form_input} ${s.login_form_input_password}`}
                />
                <button
                  type="button"
                  className={s.toggle_password_button}
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                  title={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                >
                  <img
                    src={showPassword ? eyeOpenIcon : eyeClosedIcon}
                    alt=""
                    className={s.toggle_password_icon}
                  />
                </button>
              </div>
              <div className={s.auth_form_field}>
              <input
                type="checkbox"
                id="agreement"
                name="agreement"
                checked={agreed}
                onChange={(e) => {
                  const value = e.target.checked;
                  if (typeof onPrivacyChange === 'function') {
                    onPrivacyChange(value);
                  } else {
                    setLocalPrivacyConsent(value);
                  }
                }}
              />
              <label htmlFor="agreement">
                Я принимаю условия Пользовательского соглашения и даю согласие на обработку моих персональных данных в соответствии с{' '}
                <a
                  href="#"
                  className={s.agreement}
                  onClick={(e) => {
                    e.preventDefault();
                    setShowPolicy(true);
                  }}
                >
                  <strong>Политикой конфиденциальности</strong>
                </a>
                .
              </label>
            </div>

            <div className={s.auth_form_field}>
              <input
                type="checkbox"
                id="marketingAgreement"
                name="marketingAgreement"
                checked={marketingAgreed}
                onChange={(e) => {
                  const value = e.target.checked;
                  if (typeof onMarketingChange === 'function') {
                    onMarketingChange(value);
                  } else {
                    setLocalMarketingConsent(value);
                  }
                }}
              />
              <label htmlFor="marketingAgreement">
                Я согласен на получение рекламных материалов, новостей и коммерческих предложений.
              </label>
            </div>

              
            <button
                className={s.login_form_button}
                type="submit"
                disabled={!agreed}
              >
                Зарегистрироваться
              </button>

            </form>
          )}
        </div>
        <PolicyModal isOpen={showPolicy} onClose={() => setShowPolicy(false)} />
      </div>
  );
}

export default Register;
